import { useState } from 'react';

import type { CheckPhoneVerificationCodeResponse } from '../../../../../../resources/@types/accountSchema';
import { AccountInformationByID } from './AccountInformationByID';
import { EmptyAccount } from './EmptyAccount';
import { PhoneVerify } from './PhoneVerify';

const STEP = {
  PHONE_VERIFY: 'PHONE_VERIFY',
  ACCOUNT_INFORMATION_BY_ID: 'ACCOUNT_INFORMATION_BY_ID',
  EMPTY_ACCOUNT: 'EMPTY_ACCOUNT',
};

export const FindIdPageItem = () => {
  const [step, setStep] = useState(STEP.PHONE_VERIFY);
  const [accounts, setAccounts] = useState<CheckPhoneVerificationCodeResponse[]>([]);

  const handleVerify = (responses: CheckPhoneVerificationCodeResponse[]) => {
    const isEmptyAccount = responses.length === 0;

    if (isEmptyAccount) {
      setStep(STEP.EMPTY_ACCOUNT);

      return;
    }

    setStep(STEP.ACCOUNT_INFORMATION_BY_ID);
    setAccounts(responses);
  };

  const handleRetry = () => {
    setStep(STEP.PHONE_VERIFY);
  };

  return (
    <>
      {step === STEP.PHONE_VERIFY && <PhoneVerify onVerify={handleVerify} />}
      {step === STEP.ACCOUNT_INFORMATION_BY_ID && <AccountInformationByID accounts={accounts} />}
      {step === STEP.EMPTY_ACCOUNT && <EmptyAccount onRetry={handleRetry} />}
    </>
  );
};
